import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e7c325d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "px-2" }, "Dokumendid", -1))
const _hoisted_2 = {
  key: 0,
  class: "px-2 text-textDark text-justify mt-3"
}
const _hoisted_3 = { class: "pealkiri" }
const _hoisted_4 = ["colspan"]
const _hoisted_5 = { class: "pealkiri" }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = { class: "pealkiri" }
const _hoisted_8 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoHoiatus = _resolveComponent("VoHoiatus")!
  const _component_VoKuvaRohkem = _resolveComponent("VoKuvaRohkem")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_VoHoiatus, { class: "ma-2" }),
              _hoisted_1,
              (_ctx.lehePaiseTekst && _ctx.lehePaiseTekstLuhendatud)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createVNode(_component_VoKuvaRohkem, {
                      terveTekst: _ctx.lehePaiseTekst,
                      luhendatudTekst: _ctx.lehePaiseTekstLuhendatud
                    }, null, 8, ["terveTekst", "luhendatudTekst"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "px-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                class: "rounded",
                headers: _ctx.pealkirjadeTabel.paised,
                "show-expand": "",
                "single-expand": "",
                items: [{ pealkiri: 'Ametniku lisatud dokumendid' }]
              }, {
                bottom: _withCtx(() => [
                  (_ctx.laeb)
                    ? (_openBlock(), _createBlock(_component_v_data_table, {
                        key: 0,
                        loading: _ctx.laeb
                      }, {
                        bottom: _withCtx(() => []),
                        [`headers`]: _withCtx(({ }) => []),
                        _: 2
                      }, 1032, ["loading"]))
                    : _createCommentVNode("", true)
                ]),
                [`headers`]: _withCtx(({ }) => []),
                [`item.pealkiri`]: _withCtx(({ value }) => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(value), 1)
                ]),
                "expanded-row": _withCtx(({ columns }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: columns.length
                    }, [
                      (!_ctx.laeb)
                        ? (_openBlock(), _createBlock(_component_v_data_table, {
                            key: 0,
                            headers: _ctx.ametnikuLisatudDokumendidTabel.paised,
                            items: _ctx.ametnikuLisatudDokumendidTabel.elemendid,
                            "items-per-page": _ctx.ametnikuLisatudDokumendidTabel.lehePikkus,
                            "item-key": "failiNimi"
                          }, {
                            [`item.failiId`]: _withCtx(({ value, item }) => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "text",
                                size: "x-large",
                                icon: "mdi-file-download-outline",
                                onClick: ($event: any) => (_ctx.laadiAmetnikuDokumentAlla(value, item.failiNimi, true))
                              }, null, 8, ["onClick"])
                            ]),
                            bottom: _withCtx(() => []),
                            [`headers`]: _withCtx(({ }) => []),
                            _: 2
                          }, 1032, ["headers", "items", "items-per-page"]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_4)
                  ])
                ]),
                _: 2
              }, 1032, ["headers"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "px-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                class: "rounded",
                headers: _ctx.pealkirjadeTabel.paised,
                "show-expand": "",
                "single-expand": "",
                items: [{ pealkiri: 'Kirjalikud hoiatused' }]
              }, {
                bottom: _withCtx(() => [
                  (_ctx.laeb)
                    ? (_openBlock(), _createBlock(_component_v_data_table, {
                        key: 0,
                        loading: _ctx.laeb
                      }, {
                        bottom: _withCtx(() => []),
                        [`headers`]: _withCtx(({ }) => []),
                        _: 2
                      }, 1032, ["loading"]))
                    : _createCommentVNode("", true)
                ]),
                [`headers`]: _withCtx(({ }) => []),
                [`item.pealkiri`]: _withCtx(({ value }) => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(value), 1)
                ]),
                "expanded-row": _withCtx(({ columns }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: columns.length
                    }, [
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.kirjalikudHoiatusedTabel.paised,
                        items: _ctx.kirjalikudHoiatusedTabel.elemendid,
                        "items-per-page": _ctx.kirjalikudHoiatusedTabel.lehePikkus,
                        loading: _ctx.laeb,
                        "item-key": "failiNimi"
                      }, {
                        [`item.failiId`]: _withCtx(({ value, item }) => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            size: "x-large",
                            icon: "mdi-file-download-outline",
                            onClick: ($event: any) => (_ctx.laadiHoiatuseDokumentAlla(value, item.failiNimi))
                          }, null, 8, ["onClick"])
                        ]),
                        bottom: _withCtx(() => []),
                        [`headers`]: _withCtx(({ }) => []),
                        _: 2
                      }, 1032, ["headers", "items", "items-per-page", "loading"])
                    ], 8, _hoisted_6)
                  ])
                ]),
                _: 2
              }, 1032, ["headers"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "px-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                class: "rounded",
                headers: _ctx.pealkirjadeTabel.paised,
                "show-expand": "",
                "single-expand": "",
                items: [{ pealkiri: 'Erakorralised ettekanded' }]
              }, {
                bottom: _withCtx(() => [
                  (_ctx.laeb)
                    ? (_openBlock(), _createBlock(_component_v_data_table, {
                        key: 0,
                        loading: _ctx.laeb
                      }, {
                        bottom: _withCtx(() => []),
                        [`headers`]: _withCtx(({ }) => []),
                        _: 2
                      }, 1032, ["loading"]))
                    : _createCommentVNode("", true)
                ]),
                [`headers`]: _withCtx(({ }) => []),
                [`item.pealkiri`]: _withCtx(({ value }) => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(value), 1)
                ]),
                "expanded-row": _withCtx(({ columns }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: columns.length
                    }, [
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.erakorralisedEttekannedTabel.paised,
                        items: _ctx.erakorralisedEttekannedTabel.elemendid,
                        "items-per-page": _ctx.erakorralisedEttekannedTabel.lehePikkus,
                        loading: _ctx.laeb,
                        "item-key": "failiNimi"
                      }, {
                        [`item.failiId`]: _withCtx(({ value, item }) => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            size: "x-large",
                            icon: "mdi-file-download-outline",
                            onClick: ($event: any) => (_ctx.laadiEttekandeDokumentAlla(value, item.failiNimi))
                          }, null, 8, ["onClick"])
                        ]),
                        bottom: _withCtx(() => []),
                        [`headers`]: _withCtx(({ }) => []),
                        _: 2
                      }, 1032, ["headers", "items", "items-per-page", "loading"])
                    ], 8, _hoisted_8)
                  ])
                ]),
                _: 2
              }, 1032, ["headers"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}